import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CustomerSlotsComponent } from 'src/shared/customer-slots/customer-slots.component';

@Component({
  selector: 'app-about-us',
  imports: [CustomerSlotsComponent],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss'
})
export class AboutUsComponent {
  readonly customer = environment.customer;
}
